module.exports = __webpack_public_path__ + "img/ic-money.670269ab.png";